export const isEqual = (query: string, element: string) => {
  const normalizedQuery = query.replace(/\s/gi, '')
  const normalizedElement = element.replace(/\s/gi, '')

  return normalizedQuery.toLowerCase() === normalizedElement.toLowerCase()
}

// Facebook API collapses multiple consecutive newlines to at most double newlines
export const collapseMultipleNewLines = (content?: string) => {
  return content?.replace(/(\r?\n){3,}/g, '\n\n')
}
